import { mappedColors, typography } from '@pixee/design-system'

export const ResultNotFoundFallback: React.FC = () => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      paddingTop: '64px',
      color: mappedColors.neutral.halo,
    }}
  >
    <p className={typography.paragraph}>Result not found.</p>
    <p style={{ marginTop: '8px', fontSize: '14px' }}>The specified result does not exist for this finding.</p>
  </div>
)
